import { render, staticRenderFns } from "./PageNotAllowed.vue?vue&type=template&id=ca710928&scoped=true"
import script from "./PageNotAllowed.vue?vue&type=script&lang=js"
export * from "./PageNotAllowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca710928",
  null
  
)

export default component.exports